
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as PreviousWithTextIconComponent } from "./previous-with-text-icon.svg";

export const PreviousWithTextIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <PreviousWithTextIconComponent {...props} />;
};
